import React from 'react'
import { CustomText } from 'src/components'
import { useTranslation } from 'next-i18next'
import { SdgCompilance } from 'src/core/models'
import { ProjectDetailsCollapse } from '../index'
import styles from './ProjectSdgDetailsList.module.scss'

interface PropsType { sdg_compliances: SdgCompilance[] }

const ProjectSdgDetailsList: React.FC<PropsType> = ({ sdg_compliances }) => {
  const { t } = useTranslation()

  return (
    <ProjectDetailsCollapse label={<CustomText label={t('Projects.Sdg.Title')} strong/>}>
      {sdg_compliances.map((sdg: SdgCompilance) => (
        <div className={styles['project-SDG']} key={sdg.id}>
          <div className={styles['SDG-image']} style={{
            backgroundImage: `url(${sdg.icon})`,
          }} />
          <div className={styles['SDG-text']}>
            <div className={styles['SDG-title']}> {t('sdgs.' + sdg.id)} </div>
            <div className={styles['SDG-description']}> {t('sdgs.' + sdg.id + '-title')} </div>
          </div>
        </div>
      ))}
    </ProjectDetailsCollapse>
  )
}

export default ProjectSdgDetailsList
